import { DataSource, Layout, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutEdiStopNotesAndReferenceNumbers extends Layout {
    sourceEdiRefNumber: DataSource;
    sourceEdiStopNote: DataSource;
    tabStopComments: Tab;
    tabStopRefNumbers: Tab;
    tableStopComments: Table;
    tableStopReferenceNumbers: Table;
    tabsetStopNotesRefNos: Tabset;
}
